import { keyframes } from '@emotion/core'

export const pulse = keyframes`
  from { transform: scale3d(1, 1, 1); }
  50% { transform: scale3d(1.05, 1.05, 1.05); }
  to { transform: scale3d(1, 1, 1); }
`
